import {createSelector} from '@reduxjs/toolkit'
import {RootState} from 'app/rootReducer'
import {UserState} from './userSlice'

function getUser(state: RootState): UserState {
  return state.user
}

export const selectUserProfile = createSelector(getUser, user => user?.current)

export const selectUserNotification = createSelector(
  getUser,
  user => user.notification,
)

export const storageLocationSelector = createSelector(
  getUser,
  user => user.locationStatus,
)

export const selectUser = createSelector(getUser, user => {
  return {
    ...user,
  }
})
